import React from 'react'
import Modal, {ModalBody, ModalFooter, ModalHeader} from "../../../../components/bootstrap/Modal";
import Button from "../../../../components/bootstrap/Button";
import {useTranslation} from "react-i18next";
import success from "../../../../assets/img/SuccessIcon.svg";

const WorkApprovalCompletedModal = ({ isOpen, setIsOpen }) => {
  const { t } = useTranslation()

  return (
    <Modal
      isCentered
      isStaticBackdrop
      setIsOpen={setIsOpen}
      isOpen={isOpen}
      size={'sm'}
    >
      <div className='modal-wraped mx-3'>
        <ModalHeader />
        <ModalBody>
          <div className='text-center'>
            <img src={success} alt="리스트 아이콘" width={60} />
            <p dangerouslySetInnerHTML={{ __html: t('successOTpopup.completedApplicationForEmployment') }}></p>
            <p className='text-muted mb-0'>
            {t('successConfirmPopup.checkApplicationStatusOnEApproval1')}
              <br/>     {t('successConfirmPopup.checkApplicationStatusOnEApproval2')}
            </p>
          </div>   
        </ModalBody>
        <ModalFooter className='justify-content-center'>
          <Button
            className='w-100'
            style={{
              borderRadius: 7,
            }} 
            color='success'
            onClick={() => setIsOpen(false)}
          >
            <span className='px-3'>{t('확인')}</span>
          </Button>
        </ModalFooter>
    </div>
    </Modal>
  )
}

export default React.memo(WorkApprovalCompletedModal)